import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { LoyaltyBenefits as LoyaltyBenefitsComponent } from '@thd-olt-component-react/loyalty-benefits';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function LoyaltyBenefits() {
  return (
    <ErrorBoundary name="loyalty-benefits">
      <QueryProvider cacheKey="loyalty-benefits-cacheKey">
        <LoyaltyBenefitsComponent />
      </QueryProvider>
    </ErrorBoundary>
  );
}
